import { apiSlice } from 'src/app/redux/api/apiSlice';
import { EditBlockUpdateDataType } from 'src/app/redux/block/block-slice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const blockSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    editBlock: builder.mutation<void, EditBlockUpdateDataType>({
      query: (data) => ({
        url: finalUrlsConfig().surfer.editBlock,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useEditBlockMutation } = blockSlice;
